export default "__VITE_ASSET__CjIg8vsu__"